import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';

export const reviewsService = {
    getAll,
    checkNewExist,
    exportCSV,
    assignContact,
    unassignContact,
    replyReview,
    deleteReply,
};

function getAll(params, pageToken = null, pageSize = 25) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    const nextPageToken = pageToken ? `&pageToken=${pageToken}` : '';
    return fetch(`${BASE_URL}api/reviews/query?${nextPageToken}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function checkNewExist(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/reviews/hasNew`, requestOptions).then(handleResponse);
}

function exportCSV(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/reviews/export`, requestOptions).then(handleResponseBlob);
}

function assignContact(data, reviewId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/reviews/${reviewId}:assign-contact`, requestOptions).then(handleResponse);
}

function unassignContact(reviewId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/reviews/${reviewId}:unassign-contact`, requestOptions).then(handleResponse);
}

function replyReview(data, reviewId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/reviews/${reviewId}/replies`, requestOptions).then(handleResponse);
}

function deleteReply(reviewId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/reviews/${reviewId}/replies`, requestOptions).then(handleResponse);
}
